import React from "react";
import DividendWithholdingTaxVM from "./DividendWithholdingTaxVM";
import { observer } from "mobx-react";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import DividendWithholdingTaxLookup from "../Models/Lookups/DividendWithholdingTaxLookup";
import { TextConstants } from "../../../Common/TextConstants";

interface IDividendWithholdingTaxProps {
  viewModel: DividendWithholdingTaxVM;
}

@observer
export default class DividendWithholdingTax extends React.Component<IDividendWithholdingTaxProps> {
  constructor(props: IDividendWithholdingTaxProps) {
    super(props);
  }

  public formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
}

  public render() {
    const viewModel = this.props.viewModel;

    return (
      <>
        <Neo.Card>
          {viewModel.dividendWithholdingTaxPageManager.totalRecords >
            0 && (
            <div className="inner-container">
              <Neo.Pager
                pageManager={
                  viewModel.dividendWithholdingTaxPageManager
                }
                pageControlProps={{ pageSizeLabel: "Show" }}
              >
                <div className="horizontalScroll inner-container">
                  <NeoGrid.Grid<DividendWithholdingTaxLookup>
                    className={"table-striped"}
                  >
                    {(item, meta) => (
                      <NeoGrid.RowGroup>
                        <NeoGrid.Row>
                          <NeoGrid.Column
                            display={meta.brokerAccountNumber}
                            label={TextConstants.Labels.BrokerAccountNumber}
                          />
                          <NeoGrid.Column
                            display={meta.instrument}
                            label={TextConstants.Labels.Instrument}
                          />
                          <NeoGrid.Column
                            display={meta.eventDetail}
                            label={TextConstants.Labels.EventDetail}
                          />
                          <NeoGrid.Column
                            display={meta.eventId}
                            label={TextConstants.Labels.EventID}
                          />
                          <NeoGrid.Column
                            label={TextConstants.Labels.EventDate}
                          >
                            {this.formatDate(item.eventDate)}
                          </NeoGrid.Column>
                          <NeoGrid.Column
                            display={meta.amountNC}
                            label={TextConstants.Labels.AmountNC}
                          />
                          <NeoGrid.Column
                            display={meta.excluded}
                            label={TextConstants.Labels.Excluded}
                          />
                        </NeoGrid.Row>
                      </NeoGrid.RowGroup>
                    )}
                  </NeoGrid.Grid>
                </div>
              </Neo.Pager>
            </div>
          )}
          {viewModel.dividendWithholdingTaxPageManager.totalRecords <=
            0 && (
            <div className="col-md-12 p-0 text-center">
              {TextConstants.GeneralText.NoRecords}
            </div>
          )}
        </Neo.Card>
      </>
    );
  }
}
